//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'AppBadge',

	props: {
		text: {
			required: false,
			type: String,
		},

		color: {
			required: false,
			type: String,
			default: 'muted',
		},

		icon: {
			required: false,
			type: String,
		},
	},

	computed: {
		badgeColor() {
			return {
				warning: 'bg-warning/10 border-warning/30 text-warning',
				success: 'bg-success/10 border-success/30 text-success',
				info: 'bg-primary/10 border-primary/30 text-primary',
				neutral: 'border border-border-form bg-background-primary bg-opacity-10',
			}[this.color];
		},

		iconColor() {
			return {
				warning: 'text-warning',
				success: 'text-success',
			}[this.color];
		},
	},
};
